import React from 'react';
import { Box } from '@mui/material';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsTimeline from 'highcharts/modules/timeline';
import { EventRow, TimelineChartOrientation } from '@opengov/stories-shared/types';
import { useTimelineOptions } from './useTimelineOptions';

HighchartsTimeline(Highcharts);

interface ProgressChartProps {
    events: EventRow[];
    orientation?: TimelineChartOrientation;
}

export const ProgressChart = React.memo(({ events, orientation }: ProgressChartProps) => {
    const timelineOptions = useTimelineOptions({ events, orientation });
    return (
        <Box>
            <HighchartsReact
                highcharts={Highcharts}
                options={timelineOptions}
            />
        </Box>
    );
});

ProgressChart.displayName = 'ProgressChart'; 